import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const LinkLiner24 = _ref => {
  let {
    size = 24
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M18.0033 13.7749L19.0711 12.7071C21.2065 10.5717 21.2136 7.07149 19.0711 4.92896C16.9356 2.79349 13.4354 2.78642 11.2929 4.92896L10.2252 5.99669M5.98958 10.2323L4.92892 11.2929C2.78639 13.4355 2.78639 16.9286 4.92892 19.0711C7.06438 21.2066 10.5646 21.2136 12.7071 19.0711L13.7678 18.0104M9.17156 14.8285L14.8284 9.1716",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};